export default __webpack_public_path__ + "static/media/ppt.21cc787b.svg";